import React, { useCallback, useEffect, useState } from "react";
import { InfiniteList2 } from "../../../../common/components";
import { FilterHeader, FlagHeaders, FlagPanels, FlagRow } from "./components";
import styles from "./DSIFlags.module.css";
import { BackOfficeService, FeatureManagementService } from "../../../../api";
import { useApi } from "../../../../common/hooks";

const generatePayload = (n, pid) => {
	const payload = {};
	if (n?.length) {
		payload.name = n;
	}
	if (pid) {
		payload.packageId = pid;
	}
	return payload;
};
export default function DSIFlags() {
	const { call: getAllProjects } = useApi(BackOfficeService.getAllProjects);
	const { call: getAllPlatformFeatures } = useApi(FeatureManagementService.getAllPlatformFeatures);
	const [plName, setName] = useState("");
	const [plPackageId, setPackageId] = useState(null);
	const [selectedRow, setSelectedRow] = useState(null);
	const [panel, setPanel] = useState("");
	const [count, setCount] = useState(0);
	const [infiniteListRequest, setInfiniteListRequest] = useState(null);
	const [projectsRequest, setProjectsRequest] = useState(null);
	const handleChangeFilters = useCallback(({ name, packageId }) => {
		setName(name);
		setPackageId(packageId);
	}, []);
	useEffect(() => {
		setInfiniteListRequest(
			() =>
				({ page, limit }) =>
					getAllPlatformFeatures({ page, limit }, generatePayload(plName, plPackageId))
		);
	}, [plName, plPackageId, count, getAllPlatformFeatures]);
	useEffect(() => {
		setProjectsRequest(
			() =>
				({ page, limit, search }) =>
					getAllProjects({ page, limit, filter: search })
		);
	}, [count, getAllProjects]);
	const handleSelectRow = (row, pane) => {
		setSelectedRow(row);
		setPanel(pane);
	};
	const rowRenderer = (feat) => <FlagRow feat={feat} onSelectRow={handleSelectRow} />;
	const handleClose = () => {
		setSelectedRow(null);
		setPanel("");
	};
	const handleUpdateRow = () => {
		setCount((prev) => prev + 1);
	};
	return (
		<div className={styles.container}>
			<FilterHeader onChangeFilters={handleChangeFilters} />
			<FlagHeaders />
			<div className={styles.list}>
				<InfiniteList2 request={infiniteListRequest} rowRenderer={rowRenderer} />
			</div>
			<FlagPanels
				feat={selectedRow}
				open={!!selectedRow}
				panel={panel}
				projectsRequest={projectsRequest}
				onClose={handleClose}
				onUpdateRow={handleUpdateRow}
			/>
		</div>
	);
}
